module.exports = __webpack_public_path__ + "img/zxkf_icon.519a91ec.svg";